import { useAccount } from '../context/AccountContext'

const defaultAccount = { accountId: '', grpId: '', gender: '' }

export const readAccountContext = () => {
  if (typeof window === 'undefined') {
    return defaultAccount
  }

  return {
    accountId: window.localStorage.getItem('account_ID') || '',
    grpId: window.localStorage.getItem('grp_ID') || '',
    gender: window.localStorage.getItem('gender') || '',
  }
}

const useAccountContext = () => useAccount() || defaultAccount

export default useAccountContext
